"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";

type Ad = {
  id: number;
  title: string;
  desc: string;
  cta: string;
  bg?: string;
};

const ADS: Ad[] = [
  {
    id: 1,
    title: "Grow your business",
    desc: "Reach verified buyers globally",
    cta: "Get Leads",
  },
  {
    id: 2,
    title: "Boost your visibility",
    desc: "Premium placement in search",
    cta: "Promote Now",
  },
  {
    id: 3,
    title: "Get bulk orders",
    desc: "Connect with high-volume buyers",
    cta: "Start Selling",
  },
];

export default function AdCarousel() {
  const [index, setIndex] = useState(0);
  const router = useRouter();

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ADS.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  const ad = ADS[index];

  return (
    <div className="relative h-[270px] w-full overflow-hidden rounded-[1.4rem] bg-[#141833] p-6 shadow-[0_18px_48px_rgba(15,23,42,0.28)]">

      {/* CONTENT */}
      <div key={ad.id} className="flex h-full flex-col justify-between animate-fadeIn">

        {/* TOP */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xs px-3 py-1 rounded-full bg-[#3a2f2d] text-[#f0b35a] font-semibold">
              Sponsored
            </span>
          </div>

          <h3 className="text-xl font-bold text-white leading-tight">
            {ad.title}
          </h3>

          <p className="mt-2 text-sm text-[#aeb3c7]">
            {ad.desc}
          </p>
        </div>

        {/* CTA */}
        <button
          onClick={() => router.push("/welcome")}
          className="mt-4 w-full rounded-xl bg-[#f89a34] py-3 font-semibold text-[#2d1c0b] hover:bg-[#fbab52] flex items-center justify-center gap-2"
        >
          {ad.cta}
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>

      {/* DOTS */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1">
        {ADS.map((_, i) => (
          <div
            key={i}
            className={`h-1.5 w-1.5 rounded-full transition ${
              i === index ? "bg-orange-400 w-3" : "bg-white/30"
            }`}
          />
        ))}
      </div>
    </div>
  );
}